import { Injectable } from '@angular/core';
import { Events } from 'ionic-angular';

@Injectable()
export class HelperCsvService {
  constructor(
    public events: Events
  ) {}

  exportInstructorList( instructors, fileName )
  {
    let data = [];
    // Make header row  
    let header = [
      'Registry No',
      'First Name',
      'Last Name',
      'City',
      'Phone',
      'Email Address',
      'Expiration Date',
      'Status'
    ];
    data.push( header );

    for ( let i of instructors )
    { 
      let date_expire = '';
      if ( i.certifications[0] )
      {
        date_expire = i.certifications[0].date_expire;
      }

      let row = [ i.registry_number, i.first_name, i.last_name, i.mailing_city, i.phone, i.email, date_expire || null, i.application_status ];

      data.push( row );
    }
    this.exportCsvFile( data, fileName );
  }

  exportInstructorCandidateList( instructors, fileName )
  {
    let data = [];
    // Make header row  
    let header = [
      'First Name',
      'Last Name',
      'City',
      'Phone',
      'Email Address',
      'Status'
    ];
    data.push( header );

    for ( let i of instructors )
    { 
      let row = [ i.first_name, i.last_name, i.city, i.phone, i.email, i.application_status ];

      data.push( row );
    }
    this.exportCsvFile( data, fileName );
  }

  exportInstructorsUncertifiedCandidates( instructors, fileName )
  {
    let data = [];
    // Make header row
    let header = [
      'First Name',
      'Last Name',
      'City',
      'Phone',
      'Pass Date',
      'Status'
    ];
    data.push( header );

    for ( let i of instructors )
    { 
      let row = [ i.first_name, i.last_name, i.mailing_city, i.phone, i.tse_pass_course_date, i.application_status ];

      data.push( row );
    }
    this.exportCsvFile( data, fileName );
  }

  exportProviderList( providers, fileName )
  {
    let data = [];
    // Make header row
    let header = [
      'Type',
      'Name',
      'Address 1',
      'Address 2',
      'City',
      'State',
      'Zip',
      'Mailing Address 1',
      'Mailing Address 2',
      'Mailing City',
      'Mailing State',
      'Mailing Zip',
      'Contact Name',
      'Contact Email',
      'Contact Phone',
      'Region'
    ];
    data.push( header );

    for ( let p of providers )
    { 
      let row = [ p.type, p.provider_name, p.address1, p.address2, p.city, p.state, p.zip, p.mailing_address1, p.mailing_address2, p.mailing_city, p.mailing_state, p.mailing_zip, p.contact_first_name + ' ' + p.contact_last_name, p.contact_email, p.contact_phone, p.region ];

      data.push( row );
    }
    this.exportCsvFile( data, fileName );
  }

  exportCsvFile( data, filename )
  {
    var processRow = function (row) {
      var finalVal = '';
      for (var j = 0; j < row.length; j++) {
          var innerValue = row[j] === null ? '' : row[j].toString();
          if (row[j] instanceof Date) {
              innerValue = row[j].toLocaleString();
          };
          var result = innerValue.replace(/"/g, '""');
          if (result.search(/("|,|\n)/g) >= 0)
              result = '"' + result + '"';
          if (j > 0)
              finalVal += ',';
          finalVal += result;
      }
      return finalVal + '\n';
    };

    var csvFile = '';
    for (var i = 0; i < data.length; i++) {
      csvFile += processRow(data[i]);
    }

    var blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });
    if (navigator.msSaveBlob) { // IE 10+
      navigator.msSaveBlob(blob, filename);
    } else {
      var link = document.createElement("a");
      if (link.download !== undefined) { // feature detection
          // Browsers that support HTML5 download attribute
          var url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", filename);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/providers/helpers/helper-csv-service.ts